import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isNil from 'lodash/isNil';
export function getMenuProps(vertical) {
  var menuProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (vertical) {
    return _objectSpread(_objectSpread({
      fluid: true,
      tabular: true
    }, menuProps), {}, {
      vertical: true
    });
  }
  return _objectSpread({
    attached: true,
    tabular: true
  }, menuProps);
}
export function getGridProps() {
  var gridProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var vertical = arguments.length > 1 ? arguments[1] : undefined;
  var fullWidthVertical = arguments.length > 2 ? arguments[2] : undefined;
  var activeIndex = arguments.length > 3 ? arguments[3] : undefined;
  if (!vertical) {
    return {};
  }
  if (fullWidthVertical && _isNil(activeIndex)) {
    return {
      tabWidth: 16,
      paneWidth: 0
    };
  }
  return gridProps;
}